namespace GeniuzPOS.Purchase {
    export class PoPo05DtPendingPIforIrColumns {
        static columnsKey = 'Purchase.PoPo05DtPendingPIforIr';
    }
}
